<script>
import layout from '@src/mixins/layout.vue'

export default {
  mixins: [layout],
  data() {
    return {
      displayFilter: false,
      ASC: 'asc',
      DSC: 'desc',
      isSortAsc: true,
    }
  },
  methods: {
    clear() {},
    applySort(sortOption) {
      this.$emit('sort-applied', sortOption)
      sortOption === this.ASC
        ? (this.isSortAsc = true)
        : (this.isSortAsc = false)
      this.displayFilter = false
    },
  },
}
</script>

<template>
  <v-menu
    v-model="displayFilter"
    :close-on-content-click="false"
    :nudge-width="mobile ? 400 : 200"
    :max-width="400"
    class="ma-auto"
    :offset-y="notDesktop ? notDesktop : !notDesktop"
    :offset-x="notDesktop ? !notDesktop : notDesktop"
    align="center"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        class="text-decoration-none"
        :class="$style.textTransform"
        color="primary"
        v-bind="attrs"
        v-on="on"
      >
        Sort
      </v-btn>
    </template>
    <v-card>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="px-2" :class="$style.boldTitle">
              Sort by
            </v-list-item-title>
            <div>
              <div no-gutters class="px-2" :class="$style.listItemStyle">
                <div :class="$style.arrowDiv">
                  <v-img
                    v-if="isSortAsc"
                    :class="$style.imgclss"
                    :src="require('@assets/images/safehaven/sort-arrow.png')"
                    class="mr-2 mt-1"
                  ></v-img>
                </div>
                <div :class="$style.textDiv">
                  <span :class="$style.menuText" @click="applySort(ASC)"
                    >Name: A - Z</span
                  >
                </div>
              </div>
              <div no-gutters class="px-2" :class="$style.listItemStyle">
                <div :class="$style.arrowDiv">
                  <v-img
                    v-if="!isSortAsc"
                    :class="$style.imgclss"
                    :src="require('@assets/images/safehaven/sort-arrow.png')"
                    class="mr-2 mt-1"
                  ></v-img>
                </div>
                <div :class="$style.textDiv">
                  <span :class="$style.menuText" @click="applySort(DSC)"
                    >Name: Z - A</span
                  >
                </div>
              </div>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<style lang="scss" module>
@import '@design';

.menuText {
  color: #0476d9;
}

.listItemStyle {
  display: flex;
  margin: 20px 0 5px 0;
  cursor: pointer;
}

.arrowDiv {
  flex: 1;
}

.imgclss {
  width: 6px;
  height: 10px;
}

.textDiv {
  flex: 10;
}

.textTransform {
  text-transform: none !important;
}

.lightText {
  font-size: 15px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.55) !important;
}

.boldTitle {
  font-size: 15px;
  font-weight: 600 !important;
}
</style>

<style scoped>
/deep/ .v-list-item .v-list-item__title {
  line-height: 1.3 !important;
}

/deep/ .v-input .v-label {
  font-weight: 500;
  color: #000 !important;
}
</style>
